/**
 * map — part of the German catalogue (the reference language).
 * Merged in `i18n/de.ts`; every key here must exist in `i18n/en/map.ts`.
 */

export const map = {
  /* ---------------- Karte ---------------- */
  'map.title': 'Streckenkarte',
  'map.loading': 'Karte lädt …',
  'map.error': 'Die Karte lässt sich hier gerade nicht anzeigen. Das Formular funktioniert weiter.',
  'map.diag.stalled': 'Die Karte lädt seit {s} Sekunden nicht.',
  'map.diag.nogl': 'Dieser Browser kann keine Karte zeichnen.',
  'map.diag.tiles': 'Kartendaten sind gerade nicht erreichbar.',

  'map.tool': 'Werkzeug',
  'map.tool.add': 'Strecke zeichnen',
  'map.tool.add.hint': 'Klick setzt einen Wegpunkt. Klick auf die Linie fügt dazwischen ein, Rechtsklick löscht.',
  'map.tool.info': 'Info',
  'map.tool.info.hint': 'Klick zeigt, was unter dem Zeiger liegt – Lufträume eingeschlossen.',
  'map.layers': 'Ebenen',
  'map.layer.airspaces': 'Lufträume',
  'map.layer.airports': 'Flugplätze',
  'map.layer.navaids': 'Funkfeuer',
  'map.layer.reporting_points': 'Meldepunkte',
  'map.layer.obstacles': 'Hindernisse',
  'map.layer.terrain': 'Relief',
  'map.basemap': 'Hintergrundkarte',
  'map.base.avia': 'Standard',
  'map.base.aviaDark': 'Dunkel',
  'map.base.positron': 'Hell',
  'map.base.bright': 'Bunt',
  'map.base.liberty': 'Detailreich',
  'map.fit': 'Strecke einpassen',

  'map.info.close': 'Schließen',
  'map.info.add': 'Zur Strecke',
  'map.info.alt': 'Als Ausweich',
  'map.info.alt.hint':
    'Trägt den ICAO-Code als Ausweichflugplatz ein. Bahn, Länge, Höhe und Belag kommen aus den Platzdaten.',
  'map.info.none': 'Keine weiteren Angaben.',
  'map.info.unnamed': 'ohne Namen',
  'map.info.icao': 'ICAO',
  'map.info.ident': 'Kennung',
  'map.info.kind': 'Art',
  'map.info.type': 'Typ',
  'map.info.class': 'Klasse',
  'map.info.limits': 'Untergrenze – Obergrenze',
  'map.info.elev': 'Höhe',
  'map.info.top': 'Höhe Spitze (MSL)',
  'map.info.height': 'Höhe über Grund',
  'map.info.freq': 'Frequenz',
  'map.info.rwy': 'Bahnen',
  'map.info.airport': 'Flugplatz',
  'map.info.country': 'Land',
  'map.info.compulsory': 'Pflichtmeldepunkt',
  'map.info.optional': 'Meldepunkt auf Anforderung',

  'map.kind.apt': 'Flugplatz',
  'map.kind.intl': 'Verkehrsflughafen',
  'map.kind.mil': 'Militärflugplatz',
  'map.kind.heli': 'Hubschrauberlandeplatz',
  'map.kind.glider': 'Segelfluggelände',
  'map.kind.ul': 'UL-Gelände',
  'map.kind.water': 'Wasserflugplatz',
  'map.kind.strip': 'Landebahn',
  'map.kind.agri': 'Agrarflugplatz',
  'map.kind.altiport': 'Altiport',
  'map.kind.closed': 'geschlossen',

  'map.wp.title': 'Wegpunkte',
  'map.sheet.summary': 'Wegpunkte ({n}) · {nm} NM',
  'map.sheet.empty': 'Wegpunkte (0)',
  'map.sheet.grab': 'Wegpunkte – tippen oder ziehen',
  'map.wp.empty':
    'Noch keine Wegpunkte. In den Kartenausschnitt klicken oder oben nach ICAO-Code bzw. Name suchen.',
  'map.wp.emptyRO': 'Zu diesem Plan ist keine Strecke gespeichert.',
  'map.wp.name': 'Name des Wegpunkts',
  'map.wp.alt': 'ft',
  'map.wp.alt.aria': 'Geplante Höhe (ft MSL) am Wegpunkt {n}',
  'map.wp.up': 'Nach oben',
  'map.wp.down': 'Nach unten',
  'map.wp.remove': 'Wegpunkt löschen',
  'map.wp.menu': 'Wegpunkt {n}: Menü',
  'map.wp.centre': 'Auf der Karte zentrieren',
  'map.wp.kind.airport': 'Flugplatz',
  'map.wp.kind.navaid': 'Funkfeuer',
  'map.wp.kind.reporting_point': 'Meldepunkt',
  'map.wp.kind.user': 'freier Punkt',

  'map.search.ph': 'ICAO oder Name suchen …',
  'map.search.aria': 'Flugplatz, Funkfeuer oder Meldepunkt suchen',
  'map.search.busy': 'sucht …',
  'map.search.none': 'Nichts gefunden.',

  'map.cap.legs': 'Nur zwölf Abschnitte passen aufs Formblatt – {n} weitere werden geflogen, aber nicht eingetragen.',
  'map.cap.waypoints': 'Mehr als 60 Wegpunkte sind pro Plan nicht möglich.',

  'map.check.title': 'Lufträume auf der Strecke',
  'map.check.hint': 'Hinweis, ersetzt keine Freigabe. Vor dem Flug gegen AIP und NOTAM prüfen.',
  'map.check.busy': 'prüft …',
  'map.check.total': 'Gesamtentfernung {nm} NM',
  'map.check.leg': 'Abschnitt {n}: {from} → {to} · {nm} NM',
  'map.check.clear': 'kein Luftraum in der geplanten Höhe geschnitten',
  'map.check.assumptions': 'Was diese Prüfung nicht leistet:',
  'map.assume.great_circle_leg': 'Abschnitte als kürzeste Verbindung gerechnet',
  'map.assume.gnd_as_zero': 'Grenzen über Grund wie Höhen über NN behandelt',
  'map.assume.std_fl_as_feet': 'Flugflächen als Höhe in Fuß gerechnet',
  'map.assume.no_qnh_correction': 'keine QNH-Korrektur',
  'map.assume.no_terrain': 'kein Gelände geprüft',
  'map.assume.dem_z10': 'Geländeraster rund 50 m',
  'map.assume.obstacle_top_is_lower_bound': 'Hindernisse können höher sein als angegeben',
  'map.assume.msa_is_a_suggestion': 'Sicherheitshöhe ist ein Vorschlag, keine Freigabe',

  'map.field.synced': 'aus der Karte',
  'map.field.differs': 'von Hand geändert – weicht von der Karte ab',

  /* ---------------- openAIP-Daten zur Strecke (geo.ts) ---------------- */
  'geo.field.derived': 'aus den Platzdaten {id}',
  // openAIP steht unter CC BY-NC 4.0: die Nennung gehört neben die Werte, die Lizenz hinter das ⓘ
  'geo.credit': 'Platzdaten von openAIP',
  // die Werte, die in die Bemerkungsspalte geschrieben werden — kurz, weil sie
  // in eine schmale Spalte des Papierformulars gedruckt werden
  'geo.rp.compulsory': 'Pflichtmeldepunkt',
  'geo.rp.optional': 'Meldepunkt',

  /* ---------------- Höhenwind (winds.ts, Quelle 'winds') ---------------- */
  'winds.title': 'Höhenwind',
  'winds.nolegs': 'Keine Abschnitte: mindestens zwei Wegpunkte auf der Karte setzen.',
  'winds.none': 'kein Wind',
  'winds.now.unset': 'Ohne Datum und Startzeit gilt die Vorhersage für jetzt.',
  'winds.now.outside': 'Für diese Startzeit gibt es keine Vorhersage – es gilt die für jetzt.',
  'winds.unavailable':
    'Keine Vorhersage für Abschnitt {legs} — dort bleibt stehen, was im Formular steht.',
  'winds.kept': 'W/V in Abschnitt {legs} von Hand gesetzt und deshalb nicht überschrieben.',
  // Open-Meteos Lizenz verlangt den Link neben der Anzeige — deshalb steht er dort und nicht nur hinter dem ⓘ
  'winds.credit': 'Wetterdaten von Open-Meteo.com',
  'winds.dropped': 'Nur zwölf Abschnitte passen aufs Formblatt – {n} ohne Wind.',
  'winds.stale': 'veraltet',
  'winds.stale.hint': 'Abschnitt {legs} wurde geändert – der Wind gilt noch für die alte Strecke.',
  'winds.hint':
    'Wind je Abschnitt aus der Vorhersage. Planungshilfe, keine Flugwetterberatung.',
  'winds.status.hour': 'Vorhersage {hour}',
  'winds.field.derived': 'aus dem Wind, Vorhersage {id}',
  'winds.field.derived.plain': 'aus dem Wind',
} as const;
